import { get } from 'lodash';
export class CoverageForm {
  sumAssured: number | undefined;
  planPremiumMode: string | undefined;
  illnessCover: number | undefined;
  accidentCover: number | undefined;
  promoCode: string | undefined;

  constructor(initial: any) {
    this.sumAssured = get(initial, 'sumAssured', undefined);
    this.planPremiumMode = get(initial, 'planPremiumMode', 'AP');
    this.illnessCover = get(initial, 'illnessCover', undefined);
    this.accidentCover = get(initial, 'accidentCover', undefined);
    this.promoCode = get(initial, 'promoCode', '');
  }
}